var ChiliPiperDS_PhoneVerification = new Object();

ChiliPiperDS_PhoneVerification.version = '1.0.0';
ChiliPiperDS_PhoneVerification.$form = null;
ChiliPiperDS_PhoneVerification.init = function ($form)
{

  this.$form = $form;

  const $phoneField = $form.find('input[name="phone_input_only"]');
  const $phoneHidden = $form.find('input[name="phone"]');
  const phoneMaxChars = 14;

  if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.PhoneVerification] init', $phoneField);

  $phoneField.attr("maxlength", phoneMaxChars);

  const phoneMask = /^\(\d{3}\)\s\d{3}-\d{4}$/;

  const showPhoneError = () =>
  {
    $phoneField.addClass("invalid error");
    const $errorBlock = $phoneField.closest(".input").next(".hs-error-msgs");

    const errorHTML = `
      <ul class="no-list hs-error-msgs inputs-list" role="alert">
        <li>
          <label class="hs-error-msg hs-main-font-element">
            Please enter a valid business phone number.
          </label>
        </li>
      </ul>
    `;

    if ($errorBlock.length <= 0)
    {
      $phoneField.closest(".input").after(errorHTML);
    } else
    {
      $errorBlock.html(errorHTML);
    }
  };

  const clearPhoneError = () =>
  {
    $phoneField.removeClass("invalid error");
    $phoneField.closest(".input").next(".hs-error-msgs").remove();
  };

  const isPhoneValid = (phoneFormatted) =>
  {
    var _parent = ChiliPiperDS;
    var $parentEl = _parent.$el;

    const validationEnabled = $parentEl.attr('data-phone-verification');
    const oldPhone = sessionStorage.getItem("twilio_phone_number");
    const isValidStored = !validationEnabled ? 'true' : sessionStorage.getItem("twilio_phone_number_valid");

    if (validationEnabled && (!oldPhone || oldPhone !== phoneFormatted))
    {
      sessionStorage.setItem("twilio_phone_number", phoneFormatted);

      if (helpers.shouldDebug('ds3')) console.info('[ChiliPiperDS.PhoneVerification] twilio lookup called');
      const twilioSettings = {
        type: "POST",
        url: thryvData.ajax_url,
        data: {
          phone: phoneFormatted,
          action: "twilioPhoneLookup",
        },
      };

      return jQuery
        .ajax(twilioSettings)
        .done((response) =>
        {
          if (response?.data)
          {
            const lookup_info = JSON.parse(response.data);
            if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.PhoneVerification] lookup_info:', lookup_info);

            const valid_types = ["mobile", "voip", "fixedVoip", "landline"];
            if (lookup_info?.valid && valid_types.includes(lookup_info?.line_type_intelligence?.type))
            {
              sessionStorage.setItem("twilio_phone_number_valid", "true");
              clearPhoneError();
            } else
            {
              sessionStorage.setItem("twilio_phone_number_valid", "false");
              showPhoneError();
            }
          }
        })
        .fail((xhr, status, error) =>
        {
          console.error('[ChiliPiperDS.PhoneVerification] twilio lookup failed:', xhr, status, error);
          showPhoneError();
        });
    }

    return isValidStored === "true";
  };

  $phoneField.on("keyup keydown blur input change", () =>
  {
    const rawVal = $phoneField.val();
    if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.PhoneVerification] rawVal:', rawVal);
    const phoneFormatted = ChiliPiperDS_PhoneVerification.formatPhone(ChiliPiperDS_PhoneVerification.numOnly(rawVal));
    $phoneField.val(phoneFormatted);
    $phoneHidden.val(phoneFormatted);

    if (!phoneMask.test(phoneFormatted))
    {
      showPhoneError();
      return;
    }

    const isValid = isPhoneValid(phoneFormatted);

    if (!isValid)
    {
      if (helpers.shouldDebug('ds3')) console.log('[ChiliPiperDS.PhoneVerification] isPhoneValid called');
      showPhoneError();
    } else
    {
      clearPhoneError();
    }
  });
};

ChiliPiperDS_PhoneVerification.numOnly = function (n, allowDecimal = false, max = false)
{
  if (typeof n !== "string") n = String(n);

  if (max !== false)
  {
    const maxVal = typeof max === "number" ? max.toString() : String(max);
    if (parseFloat(n) > parseFloat(maxVal))
    {
      n = maxVal;
    }
  }

  if (!allowDecimal)
  {
    return n.replace(/[^0-9]/g, "");
  } else
  {
    const formatNum = n.replace(/[^0-9.]/g, "");
    const parts = formatNum.split(".");
    const beforeDecimal = parts[0];
    const afterDecimal = parts[1] ? parts[1].slice(0, 2) : "";

    return beforeDecimal + (afterDecimal !== "" ? "." + afterDecimal.padEnd(2, "0") : "");
  }
};

ChiliPiperDS_PhoneVerification.formatPhone = function (inputVal)
{
  if (!inputVal) return "";

  let phoneNumeric = "";
  for (let i = 0; i < inputVal.length; i++)
  {
    const c = inputVal.charAt(i);
    if (!isNaN(c) && c !== " ") phoneNumeric += c;
  }

  phoneNumeric = phoneNumeric.substring(0, 10);

  if (phoneNumeric.length < 4)
  {
    return "(" + phoneNumeric;
  } else if (phoneNumeric.length < 7)
  {
    return "(" + phoneNumeric.substring(0, 3) + ") " + phoneNumeric.substring(3);
  } else
  {
    return (
      "(" +
      phoneNumeric.substring(0, 3) +
      ") " +
      phoneNumeric.substring(3, 6) +
      "-" +
      phoneNumeric.substring(6)
    );
  }
};

export default ChiliPiperDS_PhoneVerification;